import React from 'react';
import useStyle from './leaderboardNav.style';
import { classNames } from '../../../helpers/style/classNames';
import {
  BOARD_NAME,
  LeaderBoardCategories
} from '../../../types/leaderboard/leaderboard';

interface LeaderboardNavProps {
  niveau: LeaderBoardCategories;
  onClick: () => void;
  selected: boolean;
}

export const LeaderboardNav = ({
  niveau = 'classe',
  onClick,
  selected = false
}: LeaderboardNavProps) => {
  const classes = useStyle();

  return (
    <div
      onClick={onClick}
      className={classNames([classes.root, classes[niveau]], {
        condition: selected,
        classe: classes.selected
      })}
    >
      {BOARD_NAME[niveau]}
    </div>
  );
};
